var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPushLogoIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666667,
    y: 0.666667,
    width: 38.6667,
    height: 38.6667,
    rx: 4.66667,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.666667,
    y: 0.666667,
    width: 38.6667,
    height: 38.6667,
    rx: 4.66667,
    stroke: "#E5E7EB",
    strokeWidth: 1.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9799 24.6611C12.8835 24.9632 12.834 25.2835 12.834 25.6091C12.834 25.2835 12.8861 24.9632 12.9825 24.6611H12.9799ZM14.9671 17.8842H11.7922V22.7858H14.9671L15.3031 22.9213L28.8777 28.3751V12.2949L15.3031 17.7487L14.9671 17.8842Z",
    fill: "#DCFCE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9195 9.91699C29.8205 9.91699 29.7189 9.93522 29.6174 9.9769L14.6051 16.0089H10.3337C10.1045 16.0089 9.91699 16.2016 9.91699 16.4412V24.2287C9.91699 24.4683 10.1045 24.661 10.3337 24.661H12.9825C12.8861 24.9631 12.834 25.2835 12.834 25.6091C12.834 27.3254 14.2352 28.7214 15.9594 28.7214C17.4023 28.7214 18.6186 27.7421 18.978 26.4191L29.62 30.6956C29.7215 30.7347 29.8231 30.7555 29.9221 30.7555C30.3623 30.7555 30.7555 30.3857 30.7555 29.8908V10.7817C30.7529 10.2868 30.3623 9.91699 29.9195 9.91699ZM15.9594 26.854C15.2692 26.854 14.7093 26.2966 14.7093 25.6091C14.7093 25.3174 14.8108 25.0387 14.9958 24.8173L17.207 25.7054C17.1549 26.3461 16.6157 26.854 15.9594 26.854ZM28.8777 28.375L15.3031 22.9212L14.9671 22.7858H11.7922V17.8841H14.9671L15.3031 17.7487L28.8777 12.2949V28.375Z",
    fill: "#22C55E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPushLogoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/push-logo-icon.7a5d4ab914447bca1c763d23d5203984.svg";